import React, { memo } from 'react';
import ArtistCard from './ArtistCard';
import { ArtistGridProps } from '../types';

const ArtistGrid: React.FC<ArtistGridProps> = memo(({ artistsData, onArtistClick }) => {
  if (!artistsData || artistsData.length === 0) {
    return (
      <div className="artists-grid-container">
        <div className="col-span-full text-center py-12">
          <p className="text-gray-500 text-lg">אין אמנים זמינים כרגע</p>
        </div>
      </div>
    );
  }

  return (
    <div className="artists-grid-container">
      {artistsData.map((artist) => (
        <ArtistCard 
          key={artist.id} 
          artist={artist} 
          onArtistClick={onArtistClick}
        />
      ))}
    </div>
  );
});

ArtistGrid.displayName = 'ArtistGrid';

export default ArtistGrid;